import React from 'react';
import { BeeFileManager, Container } from './BeeFileManager.styled';

const MediaManager = () => {
  return (
    <Container>
      <BeeFileManager />
    </Container>
  );
};

export default MediaManager;
